__turbopack_context__.v({
  "className": "caveat_90113fcf-module__AnzHyG__className",
});
